export default __webpack_public_path__ + "static/media/nft-2.4ad03e99.png";